module.exports = __webpack_public_path__ + "img/2.215ac44c.jpg";